import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="pc-footer">
      <div className="footer-wrapper container-fluid">
        <Row>
          <Col sm={12} className="my-1">
            <p className="m-0">
              Made with &#9829; by Team{" "}
              <Link to="https://itmedia.io/" target="_blank">
                itmedia.io
              </Link>
            </p>
          </Col>
        </Row>
      </div>
    </footer>
  );
};

export default Footer;
